import { render, staticRenderFns } from "./TabelAprovalZIS.vue?vue&type=template&id=93999d66&scoped=true"
import script from "./TabelAprovalZIS.vue?vue&type=script&lang=js"
export * from "./TabelAprovalZIS.vue?vue&type=script&lang=js"
import style0 from "./TabelAprovalZIS.vue?vue&type=style&index=0&id=93999d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93999d66",
  null
  
)

export default component.exports